import React from "react";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend, Cell } from "recharts";
import { formatMoney, formatNumber } from "../../lib/api";
import { Card, pctES } from "../labresumen/Charts";

export function CruceAbcd({ rows, onPick }) {
  const desajuste = rows.filter((r) => r.pct_stock - r.pct_ventas >= 10);
  return (
    <Card title="Cruce ABCD: ventas frente a stock" testid="la-cruce-abcd"
          sub="Qué parte de tus ventas y qué parte de tu stock (a coste) cae en cada clase. Si el stock supera mucho a las ventas, sobra stock en esa clase. Pulsa una clase para ver sus productos.">
      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={rows} barGap={2}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
          <XAxis dataKey="code" tick={{ fontSize: 12, fontWeight: 700 }} />
          <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `${v} %`} width={48} />
          <Tooltip contentStyle={{ borderRadius: 6, fontSize: 12 }}
                   formatter={(v, n, it) => [n === "% ventas" ? `${pctES(v)} · ${formatMoney(it.payload.ventas_eur)}` : `${pctES(v)} · ${formatMoney(it.payload.stock_coste)} · ${formatNumber(it.payload.refs_stock)} refs`, n]} />
          <Legend wrapperStyle={{ fontSize: 12 }} />
          <Bar dataKey="pct_ventas" name="% ventas" fill="#1f6fd1" radius={[4, 4, 0, 0]} cursor="pointer" onClick={(b) => onPick(b?.payload)} />
          <Bar dataKey="pct_stock" name="% stock" fill="#f59e0b" radius={[4, 4, 0, 0]} cursor="pointer" onClick={(b) => onPick(b?.payload)} />
        </BarChart>
      </ResponsiveContainer>
      {desajuste.length > 0 && (
        <p className="text-xs text-amber-700 mt-2" data-testid="la-cruce-aviso">
          Sobra stock en {desajuste.map((r) => `${r.code} (${pctES(r.pct_stock)} del stock para ${pctES(r.pct_ventas)} de las ventas)`).join(" · ")}.
        </p>
      )}
    </Card>
  );
}

export function StockDAnios({ rows, onPick }) {
  const total = rows.reduce((t, r) => t + r.coste, 0);
  return (
    <Card title="Stock parado (D) por año de entrada" testid="la-d-anios"
          sub="Valor a coste del stock sin ventas según el año de su última entrada. Pulsa una columna para ver sus productos."
          right={<div className="text-right"><div className="text-[10px] uppercase tracking-widest text-slate-500 font-semibold">Total parado</div>
            <div className="font-display text-xl font-extrabold text-red-600" data-testid="la-d-total">{formatMoney(total)}</div></div>}>
      {rows.length === 0 ? <p className="text-sm text-slate-500 py-6 text-center" data-testid="la-d-vacio">Este laboratorio no tiene stock parado.</p> : (
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={rows}>
            <CartesianGrid strokeDasharray="3 3" stroke="#E2E8F0" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => formatMoney(v)} width={80} />
            <Tooltip contentStyle={{ borderRadius: 6, fontSize: 12 }}
                     formatter={(v, n, it) => [`${formatMoney(v)} · ${formatNumber(it.payload.refs)} refs · ${formatNumber(it.payload.uds)} uds`, "Stock D"]} />
            <Bar dataKey="coste" minPointSize={6} radius={[4, 4, 0, 0]} cursor="pointer" onClick={(b) => onPick(b?.payload)}>
              {rows.map((r, i) => <Cell key={r.key} fill={i < rows.length - 2 ? "#991b1b" : "#dc2626"} data-testid={`la-d-bar-${r.key}`} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </Card>
  );
}
